import { api } from './api'

export const fetchRespondIoSetting = () => api.get('/respond-io-setting')
export const updateRespondIoSetting = (setting) => api.put('/respond-io-setting', setting)
